export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";

export const setPage = (dispatch, payload) => {
  dispatch({ type: SET_CURRENT_PAGE, payload });
};
